// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const TargetNodeIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="TargetNodeIcon" ref={forwardedRef} {...props}>
      <path d="M13.25 4.25a5.75 5.75 0 1 1-3.929 9.946l1.06-1.06a4.25 4.25 0 1 0 .082-6.345L9.402 5.729A5.73 5.73 0 0 1 13.25 4.25" />
      <path d="m11.5 10-4.242 4.25-1.062-1.062L8.63 10.75H1V9.249h7.629L6.196 6.812 7.258 5.75z" />
    </SvgIcon>
  );
});

/**
 * Can also be used outside of the "node" context
 * @public
 */
export const TargetNodeIcon = /* @__PURE__ */ Object.assign(
  TargetNodeIconComponent,
  { displayName: 'TargetNodeIcon' },
);
